import React from 'react';
import { Box, Button, useTheme } from '@mui/material';
import { MuiLoadingButton } from '../../../components'; // Ajusta la ruta

interface FloatingActionsProps {
    isNew: boolean;           // true = modo “Crear”
    isEditing: boolean;       // cuando hay un programa existente
    loading: boolean;
    isValid: boolean;
    slugChecked: boolean | null;
    onCreate: () => void;
    onEdit: () => void;
    onCancel: () => void;
    onSave: () => void;
}

const FloatingActions: React.FC<FloatingActionsProps> = ({
    isNew,
    isEditing,
    loading,
    isValid,
    slugChecked,
    onCreate,
    onEdit,
    onCancel,
    onSave,
}) => {
    const theme = useTheme();

    // Determina si el botón de guardar/crear debe estar habilitado
    const saveEnabled = isValid && !loading && slugChecked !== false;

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: theme.spacing(3),
                right: theme.spacing(3),
                display: 'flex',
                gap: theme.spacing(2),
                zIndex: theme.zIndex.tooltip,
            }}
        >
            {isNew && (
                <MuiLoadingButton
                    buttonClasses='shadow-lg'
                    title="Crear"
                    variant="contained"
                    color="primary"
                    onClick={onCreate}
                    disabled={!saveEnabled}
                    isLoading={loading}
                />
            )}

            {!isNew && !isEditing && (
                <Button
                    className='shadow-lg'
                    variant="contained"
                    color="primary"
                    onClick={onEdit}
                    disabled={loading}
                >
                    Editar
                </Button>
            )}

            {!isNew && isEditing && (
                <>
                    <Button
                        className='bg-white px-4 shadow-lg'
                        variant="outlined"
                        color="primary"
                        onClick={onCancel}
                        disabled={loading}
                    >
                        Cancelar
                    </Button>
                    <MuiLoadingButton
                        buttonClasses='shadow-lg'

                        title="Guardar"
                        variant="contained"
                        color="primary"
                        onClick={onSave}
                        disabled={!saveEnabled}
                        isLoading={loading}
                    />
                </>
            )}
        </Box>
    );
};

export default FloatingActions;
